import { Switch, Redirect, Route } from 'react-router-dom';
import UserPreferences from '../containers/UserPreferences';
import SecurityContainer from '../containers/SecurityContainer';
import UserPreferencesSecurityContainer from '../containers/UserPreferencesSecurityContainer';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function routes() {
  const portalId = PortalIdParser.get();
  const searchParams = window.location.search.substr(1);
  return /*#__PURE__*/_jsx(Switch, {
    children: /*#__PURE__*/_jsx(Route, {
      path: "/",
      children: /*#__PURE__*/_jsxs(UserPreferences, {
        children: [/*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/user-preferences/:portalId/security",
          children: /*#__PURE__*/_jsx(Redirect, {
            to: `/settings/${portalId}/user-preferences/security?${searchParams}`
          })
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/security",
          component: SecurityContainer
        }), /*#__PURE__*/_jsx(Route, {
          exact: true,
          path: "/settings/:portalId/user-preferences/security",
          children: /*#__PURE__*/_jsx(UserPreferencesSecurityContainer, {})
        })]
      })
    })
  });
}